/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/report-section/new-products-section/report-new-products-section.component.scss */
/*# sourceMappingURL=report-new-products-section.component.css.map */
